/* eslint-disable operator-linebreak */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { validation } from './service/validations';
import { Logo } from '../components/App/Header/Logo';
import { alertActions } from '../actions/Alerts';
import { register } from './authService';
import FooterInfo from './FooterInfo';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  item: {
    paddingTop: '2em',
  },
  root: {
    fontSize: '1em',
  },
  all: {
    height: '100%',
  },
  whiteItem: {
    color: 'white;',
  },
}));

export const Register = ({ history }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const versionPackage = require('../../package.json');
  const [inputs, setUser] = useState({
    email: '',
    userType: '',
    password: '',
    showPassword: false,
  });

  const VersionNumber = styled.p`
  color: #3b3e42;
  font-size: 0.8em;
  text-align: left;
  padding: 1em;
`;

  const { email, password } = inputs;
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const registering = useSelector((state) => state.registration.registering);
  const alert = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  useEffect(() => {
    if (submitted && !errors.email && !errors.password) register(inputs, history);
    setSubmitted(false);
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(alertActions.clear());
    setErrors({});
    setUser({ ...inputs, [name]: value });
  };

  const handleClickShowPassword = () => {
    setUser({ ...inputs, showPassword: !inputs.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validation({ email, password });

    setErrors(err);

    if (!err.email && !err.password && email && password) {
      setSubmitted(true);
    }
  };

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      justifyContent="space-between"
      alignItems="center"
      className={classes.all}
    >

      <VersionNumber>
        V.
        {versionPackage.version.replace('-', '.')}
      </VersionNumber>
      <Logo />
      <Container maxWidth="xs">
        <div className={classes.paper}>
          <Typography
            color="secondary"
            align="left"
            component="h1"
            variant="h4"
          >
            {t('auth.register')}
          </Typography>
          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid item xs={12} className={classes.item}>
              <InputLabel>{t('auth.emailinput')}</InputLabel>
              <TextField
                autoComplete="off"
                name="email"
                type="email"
                fullWidth
                variant="outlined"
                required
                error={!!errors.email}
                defaultValue={inputs.email}
                onChange={handleChange}
                autoFocus
                InputProps={{
                  autoComplete: 'off',
                  form: {
                    autoComplete: 'off',
                  },
                }}
              />

              <FormHelperText className={classes.root} error={!!errors.email}>
                {errors.email && errors.email}
              </FormHelperText>
            </Grid>
            {/* PASSWORD */}
            <Grid item xs={12} className={classes.item}>
              <InputLabel>{t('auth.passwordinput')}</InputLabel>
              <TextField
                autoComplete="off"
                name="password"
                type={inputs.showPassword ? 'text' : 'password'}
                fullWidth
                variant="outlined"
                required
                error={!!errors.password}
                defaultValue={inputs.password}
                onChange={handleChange}
                autoFocus
                InputProps={{
                  autoComplete: 'new-password',
                  form: {
                    autoComplete: 'off',
                  },
                  endAdornment: (
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {inputs.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormHelperText className={classes.root} error={!!errors.password}>
                {errors.password && errors.password}
              </FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <Button
                className={classes.submit}
                type="submit"
                fullWidth
                variant="outlined"
                size="large"
                onClick={(e) => handleSubmit(e)}
                disabled={!!errors.email || !!errors.password}
              >
                {t('auth.register')}
              </Button>
              <Divider />
              <Grid
                container
                alignContent="center"
              >
                <FormHelperText className={classes.root} error={!!alert.message}>
                  {alert.message}
                </FormHelperText>
              </Grid>
            </Grid>
          </form>

          <Grid
            container
            justifyContent="space-around"
            spacing={2}
            className={classes.item}
          >
            <Link to="/">
              {t('auth.login')}
            </Link>
          </Grid>

          <Box mt={8}>
            <Grid item className={classes.whiteItem}>
              <Link style={{ color: 'gray' }} to="/booklet">Help</Link>
            </Grid>
          </Box>
          <Box mt={8}>
            <Grid item className={classes.whiteItem}>
              <Link style={{ color: '#42445d' }} to="/admin">Admin</Link>
            </Grid>
          </Box>
        </div>
      </Container>
      <FooterInfo />
    </Grid>
  );
};
